import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Theme, Tooltip, useMediaQuery, Typography } from '@mui/material';
import { ScannerCaseOrderStatus } from 'models/scanner-case';

type ScannerCaseStatusTextProps = {
    status: ScannerCaseOrderStatus;
};
const ScannerCaseStatusText: FC<ScannerCaseStatusTextProps> = ({ status }: ScannerCaseStatusTextProps) => {
    const { t: translate } = useTranslation(['scan-cases']);
    const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

    const colorMap = {
        [ScannerCaseOrderStatus.NEW]: 'success.main',
        [ScannerCaseOrderStatus.ORDER_CREATED]: 'extra.dark',
        [ScannerCaseOrderStatus.DO_NOT_IMPORT]: '#444',
    };

    return (
        <Fragment>
            <Tooltip title={<span>{translate(status)}</span>}>
                {isMobile ? (
                    <Box
                        sx={{
                            width: 14,
                            height: 14,
                            borderRadius: 7,
                            backgroundColor: colorMap[status],
                        }}
                    ></Box>
                ) : (
                    <Typography
                        variant="body2"
                        sx={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            fontWeight: 600,
                            color: colorMap[status],
                        }}
                    >
                        {translate(status)}
                    </Typography>
                )}
            </Tooltip>
        </Fragment>
    );
};

export default ScannerCaseStatusText;
